import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { axiosInstance } from '../App';
import { toast } from 'sonner';
import { Store, CheckCircle, XCircle } from 'lucide-react';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');
  const userId = searchParams.get('user_id');

  useEffect(() => {
    if (!token || !userId) {
      setStatus('error');
      setMessage('Geçersiz doğrulama linki');
      return;
    }

    verifyEmail();
  }, [token, userId]);

  const verifyEmail = async () => {
    try {
      await axiosInstance.post('/auth/verify-email', {
        token,
        user_id: userId
      });
      setStatus('success');
      setMessage('Email adresiniz başarıyla doğrulandı!');
      toast.success('Email doğrulandı');
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.data?.detail || 'Doğrulama başarısız');
      toast.error('Doğrulama başarısız');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-400 via-purple-500 to-pink-500 p-4">
      <Card className="w-full max-w-md shadow-2xl border-0 overflow-hidden">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center shadow-lg">
            <Store className="w-10 h-10 text-white" />
          </div>
          <CardTitle className="text-3xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
            Email Doğrulama
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          {status === 'verifying' && (
            <div className="space-y-4">
              <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-purple-600 mx-auto"></div>
              <p className="text-gray-600">Email adresiniz doğrulanıyor...</p>
            </div>
          )}
          
          {status === 'success' && (
            <div className="space-y-4">
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto" />
              <p className="text-lg font-semibold text-gray-800">{message}</p>
              <Button 
                onClick={() => navigate('/login')}
                className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600"
              >
                Giriş Yap
              </Button>
            </div>
          )}
          
          {status === 'error' && (
            <div className="space-y-4">
              <XCircle className="w-16 h-16 text-red-500 mx-auto" />
              <p className="text-lg font-semibold text-gray-800">{message}</p>
              <Button 
                onClick={() => navigate('/login')}
                variant="outline"
              >
                Giriş Sayfasına Dön
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
